import nxModule from 'nxModule';
import templateUrl from './report-convert.template.html';
import {ILocationService} from "angular";
import ConfirmationTemplate from "shared/common/confirmationTemplate";
import {AttachedFile, FileService} from "components/service/file.service";
import ReportService from "components/report/report.service";
import {NxRouteService} from "routes/NxRouteService";

type FileFormat = 'XML';

interface File {
  format: FileFormat;
  fileId: number;
  reportType?: string;
}

class ReportConvert {
  conversionFile: AttachedFile[] = [];

  formats: { value: FileFormat, description: string }[] = [
    {value: 'XML', description: 'XML'}
  ];

  reportTypes: { value: string, description: string }[] = [];

  input: (Omit<File, 'fileId'> & {fileId?: number}) = {
    format: 'XML',
    reportType: ''
  };

  constructor(private readonly $location: ILocationService,
              private readonly confirmationTemplate: ConfirmationTemplate,
              private readonly reportService: ReportService,
              private readonly fileService: FileService,
              private readonly $route: NxRouteService) {
    this.loadReportTypes();
  }

  async loadReportTypes(): Promise<void> {
    try {
      const types = await this.reportService.getReportTypes();
      this.reportTypes = types.map(type => ({
        value: type,
        description: type
      }));

      if (this.reportTypes.length > 0) {
        this.input.reportType = this.reportTypes[0].value;
      }
    } catch (error) {
      console.error('Failed to load report types:', error);
    }
  }

  async convertReport(): Promise<void> {
    const confirmed = await this.confirmationTemplate({
      question: `Do you want to convert this report file?`,
      details: [
        {label: 'Report type', description: this.input.reportType ?? "Invalid report type"},
        {label: 'File format', description: this.input.format}
      ]
    });

    if (!confirmed) {
      return;
    }

    const fileIds: number[] = this.conversionFile.map(file => file.id);
    const response = await this.reportService.convertReport(
      fileIds,
      this.input.reportType
    );

    if (!response || !response.attachedFileId) {
      return;
    }

    // Download the file using fileService
    const blob = await this.fileService.downloadFile(response.attachedFileId, false).toPromise();
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = response.fileName;
    a.click();
    this.$route.reload();
  }

  redirectBack(): void {
    this.$location.path('/report');
  }
}

nxModule.component('reportConvert', {
  templateUrl: templateUrl,
  controller: ReportConvert
});
